import firebase from 'firebase/app';
import React, { Component } from 'react';
import Select from 'react-select';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { Modal, Button, Col, ControlLabel, Form, FormControl, FormGroup } from 'react-bootstrap';
import { byPropKey, fromDateString, toDateString, osloLatLng } from './utils';

import codes from '../CountryCodes.js';

import "./Register.css";

class Register extends Component {
  constructor(props) {
    super(props)

    this.state = {
      location: osloLatLng,
      showModal: false
    }
  }

  componentWillMount() {
    const onPositionSuccess = (position) => {
      if (this.state.location === osloLatLng) {
        this.setState({
          location: {lat: position.coords.latitude, lng: position.coords.longitude}
        })
      }
    }

    const onPositionError = (error) => {
      console.error('Error while trying to find current location', error);
    }

    navigator.geolocation.getCurrentPosition(onPositionSuccess, onPositionError, {
      enableHighAccuracy: true,
    });
  }

  onMapClick(event) {
    this.setState({
      location: {lat: event.latLng.lat(), lng: event.latLng.lng()}
    })
  }

  showModal() {
    this.setState({
      showModal: true
    })
  }

  hideModal() {
    this.setState({
      showModal: false
    })
  }

  render() {
    return (
      <div>
        <Modal 
          show={this.state.showModal} 
          animation={false} 
          onHide={this.hideModal.bind(this)}
          style={{textAlign: "center"}}>
          <Modal.Header>
            <Modal.Title style={{margin: "0 auto"}}>Takk!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Din observasjon er registrert
          </Modal.Body>
          <Modal.Footer>
            <Button block bsStyle="success" onClick={this.hideModal.bind(this)}>Lukk</Button>
          </Modal.Footer>
        </Modal>
        <RegisterNav />
        <RegistrationForm location={this.state.location} onSubmit={this.showModal.bind(this)}/>
        <MyMapComponent
          googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyAfl0y0x_7qiCQrtvdLno9ppxrPBB81Gok"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `400px` }} />}
          mapElement={<div style={{ height: `100%` }} />}
          location={this.state.location}
          onClick={this.onMapClick.bind(this)}
        />
        <div style={{marginTop: '20px', textAlign: 'center'}}>
          Har du spørsmål ved bruk av appen?<br />
          Ta kontakt ved å sende mail til&nbsp;
          <a href = "mailto:torstein.clausen.jystad@transport.no">
            torstein.clausen.jystad@transport.no
          </a>
        </div>
      </div>
    )
  }
}

const RegisterNav = () =>
  <nav class="navbar navbar-expand-lg navbar-light bg-light navbar-collapse">
    <a class="navbar-brand">NHO Transport</a>
  </nav>

class RegistrationForm extends Component {
  constructor(props) {
    super(props);

    var date = new Date()
    var datestr = toDateString(date)


    this.state = {
      licensenr: '',
      timestamp: datestr,
      countryCode: null
    };
  }

  onSubmit = (event) => {
    var {
      licensenr,
      timestamp,
      countryCode
    } = this.state;

    const date = fromDateString(timestamp)

    licensenr = licensenr.toUpperCase()
    licensenr = licensenr.replace(' ', '')
    licensenr = licensenr.replace('-', '')

    firebase.database().ref('/observations').push({
      licensenr: licensenr,
      latitude: this.props.location.lat,
      longitude: this.props.location.lng,
      timestamp: date.toISOString(),
      countryCode: countryCode
    });

    var newDate = new Date()
    var datestr = toDateString(newDate)

    this.setState({
      licensenr: '',
      timestamp: datestr
    })

    this.props.onSubmit()
  }

  registerButton(isInvalid) {
    if (isInvalid) {
      return (
        <Button bsStyle='primary' disabled block onClick={this.onSubmit.bind(this)}>
          Registrer
        </Button>
      )
    } else {
      return (
        <Button bsStyle='primary' block onClick={this.onSubmit.bind(this)}>
          Registrer
        </Button>
      )
    }
  }

  render() {
    const {
      licensenr,
      timestamp,
      countryCode
    } = this.state;

    console.log(countryCode)

    const isInvalid =
      licensenr === '' ||
      !/^(\d|0\d|1\d|2[0-4]):(\d|[0-6]\d) (\d|[0-2]\d|3[0-1])\/(\d|0\d|1[0-2])\/(\d\d|20\d\d)$/.test(timestamp) ||
      countryCode === null;

    const countryCodes = codes.map((elem) => {
      return {
        'value': elem[0],
        'label': elem[1] + ' (' + elem[0] + ')'
      }
    })

    return (
      <Form horizontal  style={{ marginLeft: "10px", marginRight: "10px", marginBottom: "20px", marginTop: "20px" }}>
        <FormGroup>
          <Col componentClass={ControlLabel}>Landkode</Col>
          <Col>
            <Select 
              placeholder='Velg...'
              isSearchable={true}
              options={countryCodes} 
              onChange={(event) => this.setState({countryCode: event.value})}/>
          </Col>
        </FormGroup>
        <FormGroup>
          <Col componentClass={ControlLabel}>Registreringsnummer <b>(KUN BOKSTAVER OG SIFFER, UTEN MELLOMROM)</b></Col>{'  '}
          <Col>
          <FormControl
            size={9}
            value={licensenr}
            onChange={event => this.setState(byPropKey('licensenr', event.target.value))}
            type="text"
            placeholder="AB12345"
          />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col componentClass={ControlLabel}>Tidspunkt</Col>
          <Col>
          <FormControl
            value={timestamp}
            onChange={event => this.setState(byPropKey('timestamp', event.target.value))}
            type="text"
            placeholder="HH:MM DD/MM/YYYY"
          />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col componentClass={ControlLabel}>Lokasjon</Col>
          <Col>
          <FormControl
            size={9}
            value={this.props.location.lat.toFixed(4)}
            readOnly
          />
          <FormControl
            size={9}
            value={this.props.location.lng.toFixed(4)}
            readOnly
          />
          </Col>
        </FormGroup>
        <Col>
          {this.registerButton(isInvalid)}
        </Col>
      </Form>
    )
  }
}

const MyMapComponent = withScriptjs(withGoogleMap((props) =>
    <GoogleMap
      defaultZoom={9}
          defaultCenter={props.location}
      onClick={props.onClick}
    >
      <Marker
        position={props.location}
      />

    </GoogleMap>
))

export default Register;


// WEBPACK FOOTER //
// ./src/components/Register.js